import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalJsonDialog from "../EvalJsonDialog";
import "./bufs_style.css";


const initailEvknData: any = {
  idx : -1,
  task_id: "",
  document_id: "",
  source_title: "",
  difficulty: "",
  question_text: "",
  question_type: "",
  gold_answer: "",
  answer_index: "",
  cot_rationale: "",
  options: "",
  created_at: "",
  nia70: "",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const BufsWorkerPage = (props: any) => {

  const [docId, setDocId] = useState<string>("-");
  const [category, setCategory] = useState<string>("-");
  const [status, setStatus] = useState<string>("-");

  /* =========================
     문제 데이터 상태
  ========================= */
  const [question, setQuestion] = useState<string>("");
  const [questionOriginal, setQuestionOriginal] = useState<string>("");

  const [optionsOriginal, setOptionsOriginal] = useState<string>("");

  const [answer, setAnswer] = useState<string>("");
  const [answerOriginal, setAnswerOriginal] = useState<string>("");

  const [cot, setCot] = useState<string[]>([]);
  const [cotOriginal, setCotOriginal] = useState<string>("");

  /* =========================
     검수 상태
  ========================= */
  const [editReason, setEditReason] = useState<string>("");
  const [reviewReason, setReviewReason] = useState<string>("");

  /* =========================
     핸들러
  ========================= */
  // const resetQuestion = () => setQuestion(questionOriginal);
  const resetQuestion = () => setBufsDetailData({ ...bufsDetailData, question_after: questionOriginal });
  const resetOptions = () => setOptions(JSON.parse(optionsOriginal));
  const resetAnswer = () => setBufsDetailData({ ...bufsDetailData, answer_after: answerOriginal });
  const resetCot = () => setReason_path(JSON.parse(cotOriginal));

  const updatedBufs = async (isp: any) => {
    // setStatus("통과");

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("isp", isp);

    if(isp === "수정" && editReason === ""){
      alert("수정 이유를 작성하세요.")
      setBackdrop(false);
      return;
    }

    // console.log('bufsDetailData.cot_before',bufsDetailData.cot_before, JSON.stringify(JSON.parse(bufsDetailData.cot_before)) === JSON.stringify(reason_path))
    // console.log('JSON.parse(reason_path as string)',JSON.stringify(reason_path))

    const isOptionSame = bufsDetailData.question_type === '다지선다형' ? JSON.stringify(JSON.parse(bufsDetailData.options_before)) === JSON.stringify(options) : true;

    if(isp === "수정" && 
        bufsDetailData.question_before === bufsDetailData.question_after &&
        bufsDetailData.answer_before === bufsDetailData.answer_after &&
        JSON.stringify(JSON.parse(bufsDetailData.cot_before)) === JSON.stringify(reason_path) &&
        isOptionSame
      ){
        alert("질문, 정답, 보기, COT 수정이 없습니다. (수정할 내용이 없다면 '문제 통과 처리' 혹은 검토 요청을 선택해야합니다.)")
        setBackdrop(false);
        return;
      }

    if(isp === "검토 요청" && reviewReason === ""){
      alert("검토 요청 내용을 작성하세요.")
      setBackdrop(false);
      return;
    }

    const updatedBufsData = {
      ...bufsDetailData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      options: Array.isArray(options) ? options : (() => {
        try { return JSON.parse(options as string); } catch { return []; }
      })(),
      isp_yn: isp,
      edit_reason: editReason,
      review_reason: reviewReason,
    };

    // console.log('바꾼거',JSON.stringify(updatedColEvknData))
    // return;
    
    formData.append("updatedBufsData", JSON.stringify(updatedBufsData));

    await api.post("/updateBufsQuestions",formData)
    .then((res:any) => {alert(updatedBufsData.idx + " 데이터 검수 완료"); setBackdrop(false); getBufsList(true);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  };

  const handleSaveEdit = () => {
    if (!editReason.trim()) {
      alert("수정 이유를 입력하세요.");
      return;
    }
    setStatus("수정");
    // TODO: API 호출
  };

  const handleRequestReview = () => {
    if (!reviewReason.trim()) {
      alert("검토 요청 내용을 입력하세요.");
      return;
    }
    setStatus("검토 요청");
    // TODO: API 호출
  };

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const workerInfo = useSelector((state:any)=> state.userInfo.data.user.roles)
  const evltWorker = workerInfo.find(w => w.role === 'EVLT_PRC');
  const worker = evltWorker?.user_id;
  // console.log('worker',worker)

  const [bufsWorkList, setBufsWorkList] = useState([]);

  const [bufsDetailData, setBufsDetailData] = useState<any>([]);

  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [currentQuestionId, setCurrentQuestionId] =useState("");

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const [options, setOptions] = useState<any>([]);

  const options_change = (idx: number, val: string) => {
    setOptions((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const [detailInfo, setDetailInfo] = useState<any>([]);
  const [detailInfo01, setDetailInfo01] = useState<any>([]);
  const [detailInfo02, setDetailInfo02] = useState<any>([]);

  const getSentenceDetail = async (did:string, dids_data?:string) => {

      // console.log('dids',dids_data)
      
      setBackdrop(true)

      if(dids_data !== undefined){
        const dids = JSON.parse(dids_data);

        api.get('/getContextDetail',{params:{email:email, document_id:dids[0]}})
        .then((res:any) => {
    
          const datas = res.data.datas;
          // console.log('디테일 데이터', datas)
          
          if(datas && datas.length > 0){
            // 첫 번째 데이터 자동 선택
            setDetailInfo01(datas[0]);
          }
          setBackdrop(false)
          })
        .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})

        api.get('/getContextDetail',{params:{email:email, document_id:dids[1]}})
        .then((res:any) => {
    
          const datas = res.data.datas;
          // console.log('디테일 데이터', datas)
          
          if(datas && datas.length > 0){
            // 첫 번째 데이터 자동 선택
            setDetailInfo02(datas[0]);
          }
          setBackdrop(false)
          })
        .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
      }
      else{
        api.get('/getContextDetail',{params:{email:email, document_id:did}})
        .then((res:any) => {
    
          const datas = res.data.datas;
          // console.log('디테일 데이터', datas)
          
          if(datas && datas.length > 0){
            // 첫 번째 데이터 자동 선택
            setDetailInfo(datas[0]);
          }
          setBackdrop(false)
          })
        .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
      }
    }

  const getBufsList = async (selectFirst: boolean = false) => {
    
    // email != 'hafrica@hufs.ac.kr'

    setBackdrop(true)
    api.get('/bufs_questions_worker_list',{params:{email:email, worker:worker, page:page, order:order, type:"다지선다형" }})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setInstructionList(res.data);
        // setData(res.data.datas[0]);
        setBufsWorkList(res.data.datas);

        // console.log('리스트',res.data.datas)

        if (selectFirst) {
          // 호출 시 명시적으로 첫 번째 row 선택
          setBufsDetailData(res.data.datas[0])
          setCurrentQuestionId(res.data.datas[0].idx); 
          if(res.data.datas[0].task !== 'MRCR') getSentenceDetail(res.data.datas[0].document_id); 
          else getSentenceDetail(res.data.datas[0].document_id, res.data.datas[0].document_ids); 
          setBufsDetailData(res.data.datas[0]); 

          setQuestionOriginal(res.data.datas[0].question_before); 
          setOptionsOriginal(res.data.datas[0].options_before); 
          setAnswerOriginal(res.data.datas[0].answer_before); 
          setCotOriginal(res.data.datas[0].cot_before);

          setEditReason("");
          setReviewReason("");

          setReason_path(JSON.parse(res.data.datas[0].cot_after)); 
          if(res.data.datas[0].question_type === '다지선다형') setOptions(JSON.parse(res.data.datas[0].options_after));
        } else{
          if((bufsDetailData && bufsDetailData.idx == -1) || (pagination && page != pagination.current_page)){
            setBufsDetailData(res.data.datas[0])
          }
        }
        

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setBufsWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  useEffect(() => {

    getBufsList()
  }, [page, props.rowDetail]);



  const [searchTerm, setSearchTerm] = useState<string>("");
  const [searchTerm01, setSearchTerm01] = useState<string>("");
  const [searchTerm02, setSearchTerm02] = useState<string>("");
  const [searchMatches, setSearchMatches] = useState<number[]>([]);
  const [searchMatches01, setSearchMatches01] = useState<number[]>([]);
  const [searchMatches02, setSearchMatches02] = useState<number[]>([]);
  const [currentMatchIndex, setCurrentMatchIndex] = useState<number>(-1);
  const [currentMatchIndex01, setCurrentMatchIndex01] = useState<number>(-1);
  const [currentMatchIndex02, setCurrentMatchIndex02] = useState<number>(-1);
  const [highlightedText, setHighlightedText] = useState<string>("");
  const [highlightedText01, setHighlightedText01] = useState<string>("");
  const [highlightedText02, setHighlightedText02] = useState<string>("");
  const originalContextRef = React.useRef<string>("");
  const originalContextRef01 = React.useRef<string>("");
  const originalContextRef02 = React.useRef<string>("");

  useEffect(() => {
    if (detailInfo?.context) {
      originalContextRef.current = detailInfo.context;
      setHighlightedText(detailInfo.context);
      setSearchMatches([]);
      setCurrentMatchIndex(-1);
      setSearchTerm("");
    }
    if(detailInfo01?.context && detailInfo02?.context){
      originalContextRef01.current = detailInfo01.context;
      originalContextRef02.current = detailInfo02.context;
      setHighlightedText01(detailInfo01.context);
      setHighlightedText02(detailInfo02.context);
      setSearchMatches01([]);
      setSearchMatches02([]);
      setCurrentMatchIndex01(-1);
      setCurrentMatchIndex02(-1);
      setSearchTerm01("");
      setSearchTerm02("");
    }
  }, [detailInfo, detailInfo01, detailInfo02]);

  const escapeRegex = (str: string) =>
  str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const highlightSearch = useCallback(
    (term: string) => {
      const text = originalContextRef.current;
      if (!term.trim()) {
        setHighlightedText(text);
        setSearchMatches([]);
        setCurrentMatchIndex(-1);
        return;
      }

      const regex = new RegExp(`(${escapeRegex(term)})`, "gi");
      const matches: number[] = [];
      let match: RegExpExecArray | null;

      while ((match = regex.exec(text)) !== null) {
        matches.push(match.index);
      }

      const highlighted = text.replace(
        regex,
        `<mark class="search-mark">$1</mark>`
      );

      setHighlightedText(highlighted);
      setSearchMatches(matches);
      setCurrentMatchIndex(matches.length > 0 ? 0 : -1);
    },
    []
  );

  const highlightSearchMRCR01 = useCallback((term: string) => {
    const text = originalContextRef01.current;
    if (!term.trim()) {
      setHighlightedText01(text);
      setSearchMatches01([]);
      setCurrentMatchIndex01(-1);
      return;
    }

    const regex = new RegExp(`(${escapeRegex(term)})`, "gi");
    const matches: number[] = [];
    let match: RegExpExecArray | null;

    while ((match = regex.exec(text)) !== null) {
      matches.push(match.index);
    }

    setHighlightedText01(
      text.replace(regex, `<mark class="search-mark-01">$1</mark>`)
    );
    setSearchMatches01(matches);
    setCurrentMatchIndex01(matches.length > 0 ? 0 : -1);
  }, []);

  const highlightSearchMRCR02 = useCallback((term: string) => {
    const text = originalContextRef02.current;
    if (!term.trim()) {
      setHighlightedText02(text);
      setSearchMatches02([]);
      setCurrentMatchIndex02(-1);
      return;
    }

    const regex = new RegExp(`(${escapeRegex(term)})`, "gi");
    const matches: number[] = [];
    let match: RegExpExecArray | null;

    while ((match = regex.exec(text)) !== null) {
      matches.push(match.index);
    }

    setHighlightedText02(
      text.replace(regex, `<mark class="search-mark-02">$1</mark>`)
    );
    setSearchMatches02(matches);
    setCurrentMatchIndex02(matches.length > 0 ? 0 : -1);
  }, []);

  const moveNext01 = () => {
    if (searchMatches01.length === 0) return;
    setCurrentMatchIndex01(prev =>
      (prev + 1) % searchMatches01.length
    );
  };

  const movePrev01 = () => {
    if (searchMatches01.length === 0) return;
    setCurrentMatchIndex01(prev =>
      (prev - 1 + searchMatches01.length) % searchMatches01.length
    );
  };

  const moveNext02 = () => {
    if (searchMatches02.length === 0) return;
    setCurrentMatchIndex02(prev =>
      (prev + 1) % searchMatches02.length
    );
  };

  const movePrev02 = () => {
    if (searchMatches02.length === 0) return;
    setCurrentMatchIndex02(prev =>
      (prev - 1 + searchMatches02.length) % searchMatches02.length
    );
  };

  useEffect(() => {
    if (currentMatchIndex < 0) return;

    const marks = document.querySelectorAll(".search-mark");
    marks.forEach(el => el.classList.remove("current"));

    const current = marks[currentMatchIndex] as HTMLElement;
    if (current) {
      current.classList.add("current");
      current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [currentMatchIndex, highlightedText ]);

  useEffect(() => {
    const marks = document.querySelectorAll(".search-mark-01");
    marks.forEach(el => el.classList.remove("current"));

    const current = marks[currentMatchIndex01] as HTMLElement;
    if (current) {
      current.classList.add("current");
      current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [currentMatchIndex01, highlightedText01]);

  useEffect(() => {
    const marks = document.querySelectorAll(".search-mark-02");
    marks.forEach(el => el.classList.remove("current"));

    const current = marks[currentMatchIndex02] as HTMLElement;
    if (current) {
      current.classList.add("current");
      current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [currentMatchIndex02, highlightedText02]);

  const movePrev = () => {
    if (searchMatches.length === 0) return;
    setCurrentMatchIndex(prev =>
      (prev - 1 + searchMatches.length) % searchMatches.length
    );
  };

  const moveNext = () => {
    if (searchMatches.length === 0) return;
    setCurrentMatchIndex(prev =>
      (prev + 1) % searchMatches.length
    );
  };

  const clearSearch = () => {
    setSearchTerm("");
    setHighlightedText(originalContextRef.current);
    setSearchMatches([]);
    setCurrentMatchIndex(-1);
  };

  const clearSearch01 = () => {
    setSearchTerm01("");
    setHighlightedText01(originalContextRef01.current);
    setSearchMatches01([]);
    setCurrentMatchIndex01(-1);
  };

  const clearSearch02 = () => {
    setSearchTerm02("");
    setHighlightedText02(originalContextRef02.current);
    setSearchMatches02([]);
    setCurrentMatchIndex02(-1);
  };




  /* =========================
     렌더
  ========================= */
  return (
    <Box className="app-shell">
      {backdrop && ( <SearchBackDrop message={"로딩중..."}/> )}
      {/* 상단 툴바 */}
      <div className="toolbar">
        <div className="toolbar-left">
          <div>
            <div className="toolbar-label">현재 문항</div>
            <div className="toolbar-value">{bufsDetailData?.task_id}</div>
          </div>
          <div className="toolbar-divider" />
          <div>
            <div className="toolbar-label">카테고리</div>
            <div className="toolbar-value">{bufsDetailData?.category}</div>
          </div>
          <div className="toolbar-divider" />
          <div>
            <div className="toolbar-label">상태</div>
            <div className="toolbar-value chip-gray">{bufsDetailData?.status}</div>
          </div>
        </div>

      </div>

      {/* 메인 */}
      <main className="app-main">
        <div className="main-layout">
          {/* 좌측: 원문 */}
          <section className="card left-panel">
            <div className="card-header">
              <div>
                <div className="card-title">원문 텍스트</div>
                <div className="card-subtitle">
                  문서 전체 내용 (읽기 전용 · 수정 불가)
                </div>
              </div>
              <span className="chip-gray">context</span>
            </div>

            <div className="search-box" style={{display: (bufsDetailData.task !== "MRCR"? "flex":"none")}}>
              <input
                type="text"
                placeholder="문서 내 검색..."
                className="search-input"
                value={searchTerm}
                onChange={e => {
                  const val = e.target.value;
                  setSearchTerm(val);
                  highlightSearch(val);
                }}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    moveNext();
                  }
                }}
              />

              <div className="search-controls">
                <span className="search-count">
                  {searchMatches.length > 0
                    ? `${currentMatchIndex + 1}/${searchMatches.length}`
                    : "0/0"}
                </span>
                <button className="search-btn" onClick={movePrev}>▲</button>
                <button className="search-btn" onClick={moveNext}>▼</button>
                <button className="search-btn" onClick={clearSearch}>✕</button>
              </div>
            </div>

            {/* <div className="doc-tabs" id="doc-tabs" style={{display: (bufsDetailData.task === "MRCR"? "flex":"none")}}>
              <button className="tab-btn active" data-tab="0">문서 1</button>
              <button className="tab-btn" data-tab="1">문서 2</button>
            </div> */}

            <div className="search-box" style={{display: (bufsDetailData.task === "MRCR"? "flex":"none")}}>
              <input
                type="text"
                placeholder="문서 내 검색..."
                className="search-input"
                value={searchTerm01}
                onChange={e => {
                  const val = e.target.value;
                  setSearchTerm01(val);
                  highlightSearchMRCR01(val);
                }}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    moveNext01();
                  }
                }}
              />

              <div className="search-controls">
                <span className="search-count">
                  {searchMatches01.length > 0
                    ? `${currentMatchIndex01 + 1}/${searchMatches01.length}`
                    : "0/0"}
                </span>
                <button className="search-btn" onClick={movePrev01}>▲</button>
                <button className="search-btn" onClick={moveNext01}>▼</button>
                <button className="search-btn" onClick={clearSearch01}>✕</button>
              </div>
            </div>

            <div className="doc-content"  style={{display: (bufsDetailData.task === "MRCR"? "flex":"none")}}>
              <div
                className="doc-text"
                // id="doc-content-0"
                dangerouslySetInnerHTML={{ __html: highlightedText01 }}
              />
            </div>

            <div className="search-box" style={{display: (bufsDetailData.task === "MRCR"? "flex":"none")}}>
              <input
                type="text"
                placeholder="문서 내 검색..."
                className="search-input"
                value={searchTerm02}
                onChange={e => {
                  const val = e.target.value;
                  setSearchTerm02(val);
                  highlightSearchMRCR02(val);
                }}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    moveNext02();
                  }
                }}
              />

              <div className="search-controls">
                <span className="search-count">
                  {searchMatches02.length > 0
                    ? `${currentMatchIndex02 + 1}/${searchMatches02.length}`
                    : "0/0"}
                </span>
                <button className="search-btn" onClick={movePrev02}>▲</button>
                <button className="search-btn" onClick={moveNext02}>▼</button>
                <button className="search-btn" onClick={clearSearch02}>✕</button>
              </div>
            </div>

            {/* <div className="doc-content" 
                id="doc-content-1" 
                dangerouslySetInnerHTML={{ __html: highlightedText02 }}
                style={{display: (bufsDetailData.task === "MRCR"? "flex":"none")}}>
            </div> */}
            <div className="doc-content"  style={{display: (bufsDetailData.task === "MRCR"? "flex":"none")}}>
              <div
                className="doc-text"
                // id="doc-content-0"
                dangerouslySetInnerHTML={{ __html: highlightedText02 }}
              />
            </div>

            
            <div className="doc-content" style={{display: (bufsDetailData.task === "MRCR"? "none":"flex")}}>
              <div
                className="doc-content-view"
                dangerouslySetInnerHTML={{ __html: highlightedText }}
              />
            </div>
          </section>

          {/* 중앙: 문제 검수 */}
          <section className="card">
            <div className="card-header">
              <div>
                <div className="card-title">문제 내용 검수</div>
                <div className="card-subtitle">
                  GPT가 생성한 문항을 직접 읽고, 필요시 수정·통과 처리합니다.
                </div>
              </div>
              <span className="chip">Q & A</span>
            </div>

            {/* 문제 */}
            <div className="field-group">
              <div className="field-label-row">
                <div className="field-label">문제 내용</div>
              </div>
              <textarea
                value={bufsDetailData && bufsDetailData.question_after}
                onChange={(e) => {setBufsDetailData({ ...bufsDetailData, question_after: e.target.value });}}
              />
              <div className="btn-row">
                <button className="btn-ghost" onClick={resetQuestion}>
                  원본으로 되돌리기
                </button>
              </div>
            </div>

            {/* 보기 */}
            {bufsDetailData.question_type === "다지선다형" &&
              <div className="field-group" style={{backgroundColor:"#fefce8"}}>
                <div className="field-label">보기</div>
                <div className="options-grid">
                  {options && options.map((opt, idx) => (
                    <textarea
                      key={idx}
                      value={opt}
                      style={{fontSize:"12px"}}
                      onChange={e => {
                        const next = [...options];
                        next[idx] = e.target.value;
                        setOptions(next);
                      }}
                    />
                  ))}
                </div>
                <div className="btn-row">
                  <button className="btn-ghost" onClick={resetOptions}>
                    원본으로 되돌리기
                  </button>
                </div>
              </div>
            }

            {/* 정답 */}
            <div className="field-group">
              <div className="field-label">정답</div>
              <textarea
                value={bufsDetailData && bufsDetailData.answer_after}
                onChange={(e) => {setBufsDetailData({ ...bufsDetailData, answer_after: e.target.value });}}
              />
              <div className="btn-row">
                <button className="btn-ghost" onClick={resetAnswer}>
                  원본으로 되돌리기
                </button>
              </div>
            </div>

            {/* COT */}
            <div className="field-group" style={{backgroundColor:"#dbeafe"}}>
              <div className="field-label">COT</div>
              <div className="cot-grid">
                {reason_path.map((step, idx) => (
                  <textarea
                    key={idx}
                    value={step}
                    style={{fontSize:"12px"}}
                    onChange={e => {
                      const next = [...reason_path];
                      next[idx] = e.target.value;
                      setReason_path(next);
                    }}
                  />
                ))}
              </div>
              <div className="btn-row">
                <button className="btn-ghost" onClick={resetCot}>
                  원본으로 되돌리기
                </button>
              </div>
            </div>

            {/* 검수 결과 */}
            <div className="field-group pass-card">
              <label className="field-label">수정 이유</label>
              <textarea
                value={editReason}
                placeholder="문제, 보기, 정답, COT 중 어떤 부분을 어떻게 수정했는지 간단하게 적어주세요."
                onChange={e => setEditReason(e.target.value)}
              />

              <div className="btn-row">
                <button className="btn-pass" onClick={()=>updatedBufs("통과")}>
                  문제 통과 처리
                </button>
                <button className="btn-primary" onClick={()=>updatedBufs("수정")}>
                  수정 내용 저장
                </button>
              </div>

              <div className="review-section">
                <label className="field-label">검토 요청 내용</label>
                <textarea
                  value={reviewReason}
                  placeholder="검토가 필요한 이유를 구체적으로 작성해주세요. (예: 정답이 모호함, 문제 의도가 불문명함 등)"
                  onChange={e => setReviewReason(e.target.value)}
                />
                <div className="btn-row">
                  <button
                    className="btn-warning"
                    onClick={()=>updatedBufs("검토 요청")}
                  >
                    검토 요청
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* 우측 사이드바 */}
          <aside className="sidebar">
            <div className="card sidebar-main">
              <div className="card-title">할당 문제 목록</div>
              <div className="sidebar-list">
                {/* TODO: 할당 리스트 */}
                {bufsWorkList.length > 0 && bufsWorkList.map((item:any) => {
                  // const { text: badgeText, className: badgeClass } =
                    // getBadgeInfo(item.status);

                  // const displayDocId = getDisplayDocId(item);

                  return (
                    <div
                      key={item.idx}
                      className={`list-item ${currentQuestionId === item.idx ? "active" : ""}`}
                      // className={`list-item`}
                      // data-id={item.idx}
                      data-category={item.category} 
                      onClick={() => {
                        setCurrentQuestionId(item.idx); 
                        if(item.task !== 'MRCR') getSentenceDetail(item.document_id); 
                        else getSentenceDetail(item.document_id, item.document_ids); 
                        setBufsDetailData(item); 

                        setQuestionOriginal(item.question_before); 
                        setOptionsOriginal(item.options_before); 
                        setAnswerOriginal(item.answer_before); 
                        setCotOriginal(item.cot_before);

                        setEditReason("");
                        setReviewReason("");

                        setReason_path(JSON.parse(item.cot_after)); 
                        if(item.question_type === '다지선다형') setOptions(JSON.parse(item.options_after));
                      }}
                    >
                      <div className="list-item-top">
                        <span className="list-doc-id">{item.task_id}</span>
                        <span className="chip">{item.task}</span>
                      </div>

                      <div className="list-meta">
                        <span>
                          {item.task !== "MRCR"
                            ? item.document_id
                            : JSON.parse(item.document_ids).map((docId: string, idx: number) => (
                                <div key={idx}>{docId}</div>
                              ))
                          }
                          <div>{item.question_type}</div>
                        </span>
                        <span className={`badge-status status-${item.status}`}>
                          {item.status}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="card guide-card">
              <div className="card-title">검수 가이드</div>
              <ul>
                <li>문제 의미 확인</li>
                <li>보기 상호 배타성</li>
                <li>정답 근거 확인</li>
                <li>COT 논리성</li>
              </ul>
            </div>
          </aside>
        </div>
      </main>
    </Box>
  );
};

export default BufsWorkerPage;
